import reducer from './reducers';

export { default as authOperations } from './operations';
export { default as authTypes } from './types';
export { default as authActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/auth/index.js